import React, { useEffect, useState } from "react";
import {
  Button,
  Container,
  Row,
  Col,
  Form,
  Card,
  Alert,
  Modal,
} from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { db, auth } from "../firebase/firebase";
import {
  collection,
  getDocs,
  doc,
  setDoc,
  updateDoc,
  arrayUnion,
  getDoc,
  query,
  where,
  deleteDoc,
  serverTimestamp,
} from "firebase/firestore";
import "../css/Test.css";
import SuccessModal from "../views/Success";
import WelcomeModal from "./WelcomeModal";

export const categoryOrderWithIds = [
  {
    id: "4jx2EMzabASVxfbKBKxQ",
    categorie: "Votre Leadership Aujourd'hui",
  },
  { id: "Kn1O3C6oUTXlgyWn5utY", categorie: "Vos valeurs" },
  { id: "M1zQrDhFj0LYbyYVCs1H", categorie: "État d'esprit" },
  { id: "u18ckyczskXpvLmQ9wCV", categorie: "Communication" },
  { id: "yz0kVA4XJ1Ivd1eFmIHZ", categorie: "Confiance" },
  { id: "rYbeaMIQuKar27QYsXVG", categorie: "Conflit" },
  { id: "yyZWreYDX93rPRnjIkwh", categorie: "Résilience" },
  { id: "wClgeAd1l2hqzfw5l4aV", categorie: "Vous-même, aujourd'hui" },
  { id: "PC6KaYF98rIsfNwH2FTC", categorie: "Dans le futur" },
];

const Test = () => {
  const [categories, setCategories] = useState([]);
  const [currentCategoryIndex, setCurrentCategoryIndex] = useState(0);
  const [responses, setResponses] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [testDocId, setTestDocId] = useState(null);
  const [showWelcomeModal, setShowWelcomeModal] = useState(true);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const history = useHistory();

  const fetchQuestions = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "questions"));
      let questionsData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      console.log("questionsData ", questionsData);

      // Définir l'ordre exact des catégories avec leurs IDs

      // Créer un objet de mapping pour le nouvel ordre
      const orderMapping = {};
      categoryOrderWithIds.forEach((item, index) => {
        orderMapping[item.id] = index;
      });

      // Mettre à jour l'ordre dans les données en utilisant l'ID
      questionsData = questionsData.map((question) => ({
        ...question,
        ordre: orderMapping[question.id],
      }));

      // Trier les questions selon le nouvel ordre
      const sortedQuestions = questionsData.sort((a, b) => a.ordre - b.ordre);

      setCategories(sortedQuestions);
    } catch (error) {
      console.error("Error fetching questions: ", error);
    }
  };

  useEffect(() => {
    fetchQuestions();
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        const userDocRef = doc(db, "users", user.uid);
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
          setCurrentUser({ id: user.uid, ...userDocSnap.data() });
        } else {
          console.log("No such user document!");
        }
      } else {
        setCurrentUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (currentUser && !currentUser.newTestSended) {
      setShowInfoModal(true);
    }
  }, [currentUser]);

  const handleResponseChange = (question, value) => {
    setResponses((prevResponses) => ({
      ...prevResponses,
      [question]: value,
    }));
  };

  const handleBack = () => {
    if (currentCategoryIndex > 0) {
      setCurrentCategoryIndex(currentCategoryIndex - 1);
    }
  };

  const saveResponses = async () => {
    const currentCategory = categories[currentCategoryIndex];
    const testRef = collection(db, "Tests");

    if (!testDocId) {
      const newTestDocRef = doc(testRef);
      setTestDocId(newTestDocRef.id);
      const categoryResponses = currentCategory.questions.map((question) => ({
        question,
        response: responses[question],
      }));

      const newCategoryData = {
        category: currentCategory.id,
        responses: categoryResponses,
      };

      await setDoc(newTestDocRef, {
        userId: currentUser.id,
        sharedState: false,
        testDate: new Date().toISOString(),
        categories: [newCategoryData],
      });
    } else {
      const testDocRef = doc(testRef, testDocId);
      const categoryResponses = currentCategory.questions.map((question) => ({
        question,
        response: responses[question],
      }));

      const newCategoryData = {
        category: currentCategory.id,
        responses: categoryResponses,
      };

      await updateDoc(testDocRef, {
        categories: arrayUnion(newCategoryData),
      });

      if (currentCategoryIndex === categories.length - 1) {
        const userTestRef = doc(collection(db, "UserTests"), testDocId);
        await setDoc(userTestRef, {
          userId: currentUser.id,
          sharedState: false,
          testDate: new Date().toISOString(),
          testId: testDocId,
          newTestSended: currentUser?.newTestSended,
        });

        // Mettre à jour la propriété newTestSended
        const userRef = doc(db, "users", currentUser.id);
        await updateDoc(userRef, {
          newTestSended: null,
        });
      }
    }
  };

  // Fonction pour partager les résultats avec le référent (si pas admin)
  const shareResultsWithReferent = async (testId) => {
    if (!currentUser?.referentId) {
      console.log("Pas de référent assigné, pas de partage automatique");
      return;
    }

    try {
      // Récupérer les infos du référent
      const referentDocRef = doc(db, "users", currentUser.referentId);
      const referentDocSnap = await getDoc(referentDocRef);

      if (!referentDocSnap.exists()) {
        console.log("Le référent n'existe pas dans la base de données");
        return;
      }

      const referentData = { id: referentDocSnap.id, ...referentDocSnap.data() };
      console.log("=== Infos du référent ===");
      console.log("Référent:", referentData);

      // Vérifier si le référent n'est PAS admin
      if (referentData.isAdmin) {
        console.log("Le référent est admin, pas de partage automatique");
        return;
      }

      console.log("Le référent n'est pas admin, partage automatique des résultats...");

      // Partager les résultats avec le référent
      const docRef = doc(db, "UserTests", testId);
      const currentDoc = await getDoc(docRef);
      const currentData = currentDoc.data();
      const currentShareTypes = currentData?.shareTypes || [];
      const currentShareData = currentData?.shareData || [];

      // Vérifier si déjà partagé avec le référent
      if (currentShareTypes.includes("referent")) {
        console.log("Les résultats sont déjà partagés avec le référent");
        return;
      }

      // Créer le nouvel objet de partage
      const newShareInfo = {
        shareType: "referent",
        referentId: currentUser.referentId,
        ownerInfo: {
          firstName: currentUser.firstName,
          lastName: currentUser.lastName,
          userId: currentUser.id,
          role: "candidate",
        },
      };

      const updatedShareTypes = [...currentShareTypes, "referent"];
      const updatedShareData = [...currentShareData, newShareInfo];

      await updateDoc(docRef, {
        sharedState: true,
        sharedDate: serverTimestamp(),
        shareData: updatedShareData,
        shareTypes: updatedShareTypes,
      });

      console.log("Résultats partagés avec le référent avec succès !");
    } catch (error) {
      console.error("Erreur lors du partage avec le référent:", error);
    }
  };

  const handleNext = async () => {
    const currentQuestions = categories[currentCategoryIndex]?.questions || [];
    const allAnswered = currentQuestions.every(
      (q) => responses[q] && responses[q] >= 1 && responses[q] <= 9
    );

    if (!allAnswered) {
      setShowAlert(true);
      return;
    }

    setShowAlert(false);
    await saveResponses();

    if (currentCategoryIndex < categories.length - 1) {
      setCurrentCategoryIndex(currentCategoryIndex + 1);
    } else {
      // Fin du test : partager automatiquement avec le référent si pas admin
      if (testDocId) {
        await shareResultsWithReferent(testDocId);
      }
      setShowSuccessModal(true); // Show success modal
    }
  };

  const formatQuestion = (question) => {
    return question.charAt(0)?.toUpperCase() + question.slice(1).toLowerCase();
  };

  const currentCategory = categories[currentCategoryIndex];

  const getEvaluationTitle = (index) => {
    switch (index) {
      case 1:
        return "Évaluez l'importance de ces dimensions à vos yeux";
      case 5:
        return "Évaluez les situations suivantes";
      case 8:
        return "Évaluez les affirmations suivantes";
      default:
        return "Évaluez les dimensions suivantes";
    }
  };

  return (
    <Container fluid>
      {!currentUser?.newTestSended ? (
        <Col md="12">
          <Card style={{ borderRadius: "4px" }}>
            <Card.Body>
              <span>
                Votre coach va vous autoriser l'accès au questionnaire
              </span>
            </Card.Body>
          </Card>
        </Col>
      ) : (
        <Row className="justify-content-center mt-5">
          <Col md="10">
            <Card
              style={{ borderRadius: "4px", paddingLeft: 20, paddingTop: 20 }}>
              <Card.Header>
                <div style={{ marginBottom: "1rem" }}>
                  <div style={{ fontSize: "1rem", color: "#424242" }}>
                    <strong>Boutons de navigation ci-dessous</strong>
                  </div>
                </div>
                <Card.Title as="h4">
                  <strong>
                    {" "}
                    Page {currentCategoryIndex + 1} sur {categories.length}
                  </strong>
                </Card.Title>
                <Card.Title as="h4">
                  {getEvaluationTitle(currentCategoryIndex)}
                  {/*   {currentCategory?.categorie || ""} */}
                </Card.Title>
                <div
                  style={{
                    fontSize: "0.9rem",
                    color: "#424242",
                    fontStyle: "italic",
                  }}>
                  (1 = faible à 9 = élevé)
                </div>
                {/* <div
                  style={{
                    fontSize: "1rem",
                    color: "#424242",
                    fontStyle: "italic",
                    marginTop: "0.5rem",
                  }}>
                  <strong>Évaluez :</strong>
                </div> */}
              </Card.Header>
              <Card.Body>
                {showAlert && (
                  <Alert variant="danger">
                    Veuillez répondre à toutes les questions avant de continuer.
                  </Alert>
                )}
                {currentCategory ? (
                  currentCategory.questions.map((q, index) => (
                    <Form.Group key={index} className="mb-4">
                      <Form.Label>
                        <span style={{ fontWeight: "bold", color: "#424242" }}>
                          {index + 1}.
                        </span>
                        <span style={{ fontWeight: "600", color: "#424242" }}>
                          {" "}
                          {formatQuestion(q)}
                        </span>
                      </Form.Label>
                      <div className="radio-group">
                        {[...Array(9).keys()].map((i) => (
                          <span className="radio-container" key={i}>
                            <span className="radio-label">{i + 1}</span>
                            <input
                              type="radio"
                              className="custom-radio"
                              name={`question-${index}`}
                              value={i + 1}
                              checked={responses[q] === i + 1}
                              onChange={() => handleResponseChange(q, i + 1)}
                            />
                          </span>
                        ))}
                      </div>
                    </Form.Group>
                  ))
                ) : (
                  <p>Chargement des questions...</p>
                )}
              </Card.Body>
              <Card.Footer className="d-flex justify-content-between">
                <div>
                  <Button
                    variant="secondary"
                    onClick={handleBack}
                    disabled={currentCategoryIndex === 0}>
                    Retour
                  </Button>
                </div>
                <div>
                  <Button style={{ color: "#fff" }} onClick={handleNext}>
                    {currentCategoryIndex === categories.length - 1
                      ? "Terminer"
                      : "Suivant"}
                  </Button>
                </div>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      )}

     {/*  {showInfoModal && (
        <Modal show={true} onHide={() => setShowInfoModal(false)}>
          <Modal.Header>
            <Modal.Title>Information importante</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Votre demande pour passer un nouveau questionnaire a bien été
              envoyée à l'administrateur. Vous serez informé(e) dès qu'elle aura
              été traitée.
            </p>
            <p>
              (Si votre demande a déjà été prise en compte, merci de ne pas
              tenir compte de ce message.)
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={() => setShowInfoModal(false)}
              style={{ color: "#fff" }}>
              fermer
            </Button>
          </Modal.Footer>
        </Modal>
      )} */}

      <WelcomeModal
        show={showWelcomeModal && currentUser?.newTestSended}
        onHide={() => setShowWelcomeModal(false)}
        userName={currentUser?.firstName || "Utilisateur"}
      />

      <SuccessModal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        callToAction={() => {
          history.push("/user/home");
        }}
      />
    </Container>
  );
};

export default Test;
